<template src='./VehicleType.html'></template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("vehicleType");
import { orderBy } from "@progress/kendo-data-query";

import { MESSAGES } from "@/utils/constants";
import { notify, notifyApiError } from "@/utils/notification-helper";
import CommandCell from "@/components/CommandCellTemplateWithoutAuditLog";
import DialogBox from "@/components/DialogBox.vue";

export default {
  data: function() {
    return {
      skip: 0,
      take: 10,
      pageSize: 10,
      search: "",
      pageable: {
        pageSizes: true,
        previousNext: true
      },
      add: true,
      sort: [{ field: "id", dir: "asc" }],
      columns: [
        { field: "id", title: "ID", hidden: true},
        { field: "name", title: "Name" },
        { cell: CommandCell, title: "Actions", width: "200px" }
      ],
      dataItems: [],
      index: null,
      removeData: {}
    };
  },
  methods: {
    async getDataOnload() {
        this.$store.dispatch("vehicleType/getVehicleTypes");
    },
    addVehicleType: function() {
      this.$router.push({ name: "AddVehicleType", params: { add: true } });
    },
    edit: function(item) {
      return this.$store
        .dispatch("vehicleType/getVehicleTypeById", item.dataItem)
        .then(() => {
          this.$router.push({ name: "AddVehicleType", params: { add: false } });
        });
    },
    remove: function(item) {
      this.removeData = item;
      this.$refs.removeTenantDtl.openWindow();
    },
    OkMethod() {
      return this.$store
        .dispatch("vehicleType/deleteVehicleType", this.removeData.dataItem)
        .then(() => {
          notify(MESSAGES.CHANGES_SAVE_SUCCESS);
        })
        .catch(notifyApiError);
    },
    closeDialog() {
      this.$refs.removeTenantDtl.closeWindow();
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    }
  },
  computed: {
    ...mapState({
      vehicleTypes: state => state.vehicleTypes
    }),
    total() {
      return this.vehicleTypes ? this.vehicleTypes.length : 0;
    },
    items: {
      get: function() {
        if(this.search){
          let data = this.vehicleTypes.filter(vehicle => `${vehicle.name}`.match(new RegExp(this.search, "i")));
          return orderBy(data.slice(this.skip, this.take + this.skip), this.sort);
        }else{
          return orderBy(
            this.vehicleTypes.slice(this.skip, this.take + this.skip),
            this.sort
          );
        }
      }
    }
  },

  created: function() {
    this.getDataOnload();
  },
  components: {
    DialogBox
  },
};
</script>
